module.exports = __webpack_public_path__ + "img/symbol_6.293002c4.png";